import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DirettaPortaleComponent } from './diretta-portale.component';

const routes: Routes = [
  { path: '', component: DirettaPortaleComponent }
];
@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class DirettaPortaleRouting { }


// WEBPACK FOOTER //
// ./src/app/diretta-portale/diretta-portale.routing.ts